export default "__VITE_ASSET__BbdwNDJ5__"